// import PropTypes from "prop-types";
// import { useSelector } from "react-redux";
// import clsx from "clsx";
// import { useEffect, useState } from "react";
// import { getData1 } from "../../Apis/ApiCalls";
// import { API_ENDPOINT, GET_ALL_PROMOCODES } from "../../config";

// const HeaderMedium = ({ borderStyle }) => {
//   const currency = useSelector((state) => state.currency);

//   const [offers, setOffers] = useState([]);

//   useEffect(() => {
//     const fetchOffers = async () => {
//       const response = await getData1(`${API_ENDPOINT}${GET_ALL_PROMOCODES}?promo=OFFER`);
//       console.log('response: ', response);
//       setOffers(response.detail.rows);
//     };
//     fetchOffers();
//   }, []);

//   return (
//     <div
//       className={clsx(
//         "header-top-wap",
//         borderStyle === "fluid-border" && "border-bottom"
//       )}
//     >
//       <div style={styles.offerContainer}>
//         <p style={styles.offerText}>
//           {offers.length > 0 && offers[0].description}
//         </p>
//       </div>
//     </div>
//   );
// };

// HeaderMedium.propTypes = {
//   borderStyle: PropTypes.string,
// };

// const styles = {
//   offerContainer: {
//     width: "100%",
//     // backgroundColor: "#ff0000", 
//     backgroundColor: "black",
//     textAlign: "center", // Center the text
//     height: "30px", // Height of the container
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center", // Ensure text is centered horizontally
//   },
//   offerText: {
//     fontSize: "14px",
//     color: "#fff",
//     fontWeight: "bold",
//     margin: 0,
//   },
// };

// export default HeaderMedium;


// NEW RESPONSIVE DESIGN
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { getData1 } from "../../Apis/ApiCalls";
import { API_ENDPOINT, GET_ALL_PROMOCODES } from "../../config";

const HeaderMedium = ({ borderStyle }) => {
  const currency = useSelector((state) => state.currency);

  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const fetchOffers = async () => {
      const response = await getData1(`${API_ENDPOINT}${GET_ALL_PROMOCODES}?promo=OFFER`);
      setOffers(response.detail.rows);
    };
    fetchOffers();
  }, []);

  return (
    <div
      className={clsx(
        "header-top-wap",
        borderStyle === "fluid-border" && "border-bottom"
      )}
    >
      <div style={styles.offerContainer}>
        <p style={styles.offerText}>
          {offers.length > 0 && offers[0].description}
        </p>
      </div>
    </div>
  );
};

HeaderMedium.propTypes = {
  borderStyle: PropTypes.string,
};

const styles = {
  offerContainer: {
    width: "100%",
    backgroundColor: "black",
    textAlign: "center",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 10px", // Add padding to prevent cropping
    boxSizing: "border-box", // Ensure padding doesn't affect width
  },
  offerText: {
    fontSize: "14px",
    color: "#fff",
    fontWeight: "bold",
    margin: 0,
    lineHeight: "1.2", // Ensure better spacing for multi-line text
    wordWrap: "break-word", // Allow breaking of long words
  },
};

// Add media queries for responsiveness
const mobileStyles = `
  @media (max-width: 768px) {
    .header-top-wap {
      height: auto; /* Allow dynamic height */
      padding:8px;
      background-color:black
    }
    .header-top-wap p {
      font-size: 12px; /* Reduce font size for smaller screens */
      line-height: 1.5; /* Add extra spacing for readability */
      padding: 5px 10px; /* Add padding for text inside the container */
    }
  }
`;

// Injecting the media styles into the head of the document
const styleTag = document.createElement("style");
styleTag.innerHTML = mobileStyles;
document.head.appendChild(styleTag);

export default HeaderMedium;
